// * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// * Copyright 2023 The Geek-AI Authors. All rights reserved.
// * Use of this source code is governed by a Apache-2.0 license
// * that can be found in the LICENSE file.
// * @Author yangjian102621@163.com
// * +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont2/iconfont.css";
import "vant/lib/index.css";
import App from "./App.vue";
import { createPinia } from "pinia";
import { router } from "@/router";
import "v3-waterfall/dist/style.css";
import V3waterfall from "v3-waterfall";
import Vue3DraggableResizable from "vue3-draggable-resizable";
import "vue3-draggable-resizable/dist/Vue3DraggableResizable.css";
import VideoPlayer from "vue-video-player/src";
import "video.js/dist/video-js.css";
require("vue-video-player/src/custom-theme.css");
import "@/assets/css/global.scss";

import Particles from "@tsparticles/vue3";
//import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "@tsparticles/slim";

// import 'uno.css'

import PageTableTemplate from "./components/PageTableTemplate/PageTableTemplate.vue";
import PageCardTemplate from "./components/PageTableTemplate/PageCardTemplate.vue";


const app = createApp(App);

app.component("PageTableTemplate", PageTableTemplate);
app.component("PageCardTemplate", PageCardTemplate)

app.use(createPinia());
app.use(V3waterfall);
app.use(Vue3DraggableResizable);
app.use(VideoPlayer);
app.use(Particles, {
  init: async (engine) => {
    // await loadFull(engine); // you can load the full tsParticles library from "tsparticles" if you need it
    await loadSlim(engine); // or you can load the slim version from "@tsparticles/slim" if don't need Shapes or Animations
  },
});

app.use(router).use(ElementPlus).mount("#app");
